'use client';

import { Box, Button, LinearProgress, Typography } from '@mui/material';
import { useQuery } from '@parkchirp/api-client';
import React from 'react';

import { GET_PASH_DETAILS } from '../../../queries';

interface PASHDetailModalProps {
	pashId: number;
	handleClose: () => void;
}

export const PASHDetailModal = ({ pashId, handleClose }: PASHDetailModalProps) => {
	const { data: pashInfo, loading: pashInfoLoading } = useQuery(GET_PASH_DETAILS, {
		variables: {
			id: pashId,
		},
		context: {
			apiVersion: 'v2',
		},
		fetchPolicy: 'network-only',
	});

	return (
		<Box
			sx={{
				width: '40vh',
				height: '40vh',
				p: 5,
				backgroundColor: 'white',
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			{pashInfoLoading && <LinearProgress sx={{ zIndex: 101 }} data-cy='linear-progress-indicator' />}

			<Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
				<Typography variant='h6' gutterBottom>
					Details:
				</Typography>
				{pashInfo?.getPashDetails?.response?.length ? (
					<ul style={{ paddingLeft: '20px', margin: 0 }}>
						{pashInfo.getPashDetails.response.map((error, index) => (
							<li key={index}>
								<Typography variant='body2'>{error}</Typography>
							</li>
						))}
					</ul>
				) : (
					<Typography variant='body2' color='textSecondary'>
						No details available.
					</Typography>
				)}
			</Box>

			<Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
				<Button
					sx={{ border: '1px solid', maxHeight: '25px' }}
					variant='outlined'
					onClick={handleClose}
					data-cy='close-button'
				>
					Close
				</Button>
			</Box>
		</Box>
	);
};
